import { Checkbox as HuiCheckbox, Field, Label } from "@headlessui/react";
import { Check, Minus } from "lucide-react";

import { cn } from "./cn";

interface CheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string;
  /** Доступное имя, когда видимой подписи нет — например, галочка в ячейке таблицы. */
  ariaLabel?: string;
  /** Промежуточное состояние — «выбрана часть», для заголовков списков. */
  indeterminate?: boolean;
  disabled?: boolean;
  className?: string;
}

export function Checkbox({
  checked,
  onChange,
  label,
  ariaLabel,
  indeterminate = false,
  disabled = false,
  className,
}: CheckboxProps) {
  const box = (
    <HuiCheckbox
      checked={checked}
      onChange={onChange}
      disabled={disabled}
      indeterminate={indeterminate}
      aria-label={ariaLabel}
      className={cn(
        "group relative flex size-[18px] shrink-0 items-center justify-center rounded-sm border",
        // Под пальцем цель — 44 px: невидимый псевдоэлемент вокруг квадрата.
        "pointer-coarse:after:absolute pointer-coarse:after:-inset-[13px] pointer-coarse:after:content-['']",
        "border-line bg-surface transition-colors",
        "data-checked:border-accent data-checked:bg-accent",
        "data-indeterminate:border-accent data-indeterminate:bg-accent",
        "data-disabled:cursor-not-allowed data-disabled:opacity-50",
        className,
      )}
    >
      {indeterminate ? (
        <Minus className="size-3 text-accent-fg" aria-hidden />
      ) : (
        <Check className="size-3 text-accent-fg opacity-0 group-data-checked:opacity-100" aria-hidden />
      )}
    </HuiCheckbox>
  );

  if (label === undefined) return box;

  return (
    // Промежуток между квадратом и подписью — отступ самой подписи, а не gap:
    // так щелчок между ними тоже попадает в цель и переключает флажок.
    <Field className="flex cursor-pointer items-center">
      {box}
      <Label className="cursor-pointer self-stretch py-0.5 pl-2 text-sm text-fg select-none">{label}</Label>
    </Field>
  );
}
